<template>
    <div class="flex flex-col vue__tabs-wrapper">
        <div class="inline-flex flex-wrap items-start gap-3 lg:items-center">
            <slot name="tabs" :active-tab="activeTab" :set-active-tab="setActiveTab">
                <TabButton :error="item.hasError" :name="getName(item, name)" v-for="(item, name) in tabs"  :key="getName(item, name)">
                    {{ textField ? item[textField] : item }}
                </TabButton>
            </slot>

            <slot name="actions" v-bind="{ setActiveTab }" />
        </div>

        <slot :active-tab="activeTab" />
    </div>
</template>

<script setup>
import TabButton from "./TabButton.vue";
import {ref, defineProps, defineEmits, watch} from "vue";

const props = defineProps({
    tabs: Object|Array,
    textField: String,
    nameField: String,
    default: {
        type: String,
        required: false,
        default: null
    }
})

const emit = defineEmits(['tab-change'])

const activeTab = ref(props.default ? props.default : null)

function getName(item, name) {
    return props.nameField && item ? item[props.nameField] : name
}

watch(activeTab, (newVal) => {
    emit('tab-change', newVal)
})

function setActiveTab(name) {
    activeTab.value = name
}

defineExpose({
    setActiveTab,
    activeTab
})
</script>
